<script>
  import { setContext } from 'svelte';
  export let activeCard = 0;

  let startIndex = 0;

  setContext('SetIndex', {
    index: () => {
      startIndex += 1;
      return startIndex;
    }
  })

  function reset() {
    activeCard = 0;
  }

</script>

<div class="card-grid" class:has-flipped-card={activeCard > 0} on:click={reset}>
  <slot></slot>
</div>
